import { tv } from '@change/ds-utils';

const createSizeVariant = (
	base: string,
	sizes: Readonly<{ xsmall?: string; small: string; medium: string; large: string }>,
) => tv({ base, variants: { size: sizes } });

export const HeaderStyles = createSizeVariant('flex flex-col', {
	xsmall: 'gap-[5px]',
	small: 'gap-[5px]',
	medium: 'gap-2.5',
	large: 'gap-2',
});

export const NotchStyles = createSizeVariant(
	'bg-fill-selected-strong text-typography-inverse-strong flex flex-row items-start self-center font-[Arial]',
	{
		small: 'h-2 w-[45px] rounded-b-[3px] px-1 py-px',
		medium: 'h-[15px] w-[89px] rounded-b-md px-2 py-0.5',
		large: 'rounded-b-medium h-[17px] w-[98px] px-2 py-0.5',
	},
);

export const NotchTextStyles = createSizeVariant('font-semibold leading-[140%]', {
	small: 'text-[4px]',
	medium: 'text-[8px]',
	large: 'text-[9px]',
});

export const SubredditInfoStyles = createSizeVariant('flex flex-row items-center', {
	small: 'mb-[5px] gap-1 pl-[5px]',
	medium: 'mb-2.5 gap-2 pl-2.5',
	large: 'mb-[9px] gap-2 px-3',
});

export const SubredditImageStyles = createSizeVariant(
	'outline-stroke-weaker flex items-center justify-center overflow-hidden rounded-full outline outline-offset-0',
	{ small: 'h-3.5 w-3.5 outline-[0.5px]', medium: 'h-7 w-7 outline-[1px]', large: 'h-8 w-8 outline-[1px]' },
);

export const SubredditNameStyles = createSizeVariant('font-[Arial] font-bold leading-[140%] tracking-[-1.1%]', {
	small: 'text-[5px]',
	medium: 'text-[10px]',
	large: 'text-[11px]',
});

export const RedditIconStyles = createSizeVariant('', {
	small: 'h-[10px] w-[10px]',
	medium: 'h-[18px] w-[18px]',
	large: 'h-[20px] w-[20px]',
});

export const SubredditFollowersStyles = createSizeVariant(
	'tracking-0 text-typography-weak font-[Arial] font-normal leading-[120%]',
	{
		small: 'text-[4.5px]',
		medium: 'text-[9px]',
		large: 'text-[10px]',
	},
);

export const SeparatorStyles = createSizeVariant('m-0 p-0', {
	small: 'border-t-[0.5px]',
	medium: 'border-t',
	large: 'border-t',
});
